import { render, staticRenderFns } from "./SpecialArea.vue?vue&type=template&id=2495fef8&"
import script from "./SpecialArea.vue?vue&type=script&lang=js&"
export * from "./SpecialArea.vue?vue&type=script&lang=js&"
import style0 from "./SpecialArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports